/* src/app/modules_v2/finance/loan/components/loan-attachment-dialog/loan-attachment-dialog.component.scss */
.la-header-text {
  min-width: 0;
  padding-right: 32px;
}
.la-info {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 14px;
  margin-bottom: 14px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #4b5563;
}
.la-info mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  color: #6b7280;
}
.la-upload {
  width: 100%;
  box-sizing: border-box;
}
.la-field--invalid .la-upload {
  border-color: #dc2626;
  color: #dc2626;
}
.la-upload__icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
}
.la-upload__name {
  font-weight: 600;
  color: #1a1d23;
  word-break: break-all;
}
.la-upload__input {
  display: none;
}
.la-error {
  margin-top: 8px;
}
.la-link {
  border: none;
  background: transparent;
  padding: 0;
  margin-top: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  cursor: pointer;
}
.la-link:hover {
  color: #1a1d23;
  text-decoration: underline;
}
.la-alert {
  margin: 14px 0 0;
}
/*# sourceMappingURL=loan-attachment-dialog.component.css.map */
